import {
    Card,
    createStyles,
    Grid,
    IconButton,
    Menu,
    MenuItem,
    Typography,
    withStyles,
    WithStyles,
} from '@material-ui/core';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import _ from 'lodash';
import { inject } from 'mobx-react';
import moment from 'moment';
import * as React from 'react';
import ConfirmMenuItem from 'src/common/ConfirmMenuItem/ConfirmMenuItem';
import { IActionItem } from 'src/Definitions';
import { AssessmentDto } from 'src/generated_client';
import { IStores } from 'src/Stores';
import ActionStatuses from 'src/utils/ActionStatuses';

const styles = () =>
    createStyles({
        actionItemContainers: {
            paddingBottom: '2px',
            paddingLeft: '2px',
            paddingTop: '1px',
            wordBreak: 'break-all',
        },
        actionItemName: {
            backgroundColor: '#326a85',
            padding: '3px',
        },
        actionItemNameText: {
            color: '#000000',
        },
        icon: {
            color: '#ffffff',
        },
        moreIcon: {
            fontSize: '10px',
            margin: '0px',
            padding: '0px',
        },
        notesNumber: {
            alignItems: 'center',
            display: 'flex',
        },
        paper: {
            borderColor: '#668fa3',
            borderStyle: 'solid',
            borderWidth: '2px',
            height: '200px',
            minWidth: '135px',
            padding: '0px',
            width: '100%',
        },
    });

interface IActionItemProps extends WithStyles<typeof styles> {
    actionItem: IActionItem;
    assessment: AssessmentDto;
    editActionItem: (actionItem: IActionItem) => void;
    deleteActionItem?: (actionItem: IActionItem) => Promise<void>;
    getAllActionItems?: () => void;
}

class ActionItem extends React.Component<IActionItemProps> {
    public state = {
        isToggleColumnMenuOpen: false,
        toggleColumnMenuAnchorEl: null,
    };

    private toggleActionItemMenu = (event: React.MouseEvent) => {
        let toggleColumnMenuAnchorEl = null;
        if (!this.state.isToggleColumnMenuOpen) {
            toggleColumnMenuAnchorEl = event.currentTarget;
        }
        this.setState({
            isToggleColumnMenuOpen: !this.state.isToggleColumnMenuOpen,
            toggleColumnMenuAnchorEl,
        });
    };

    public editActionItem = (event: React.MouseEvent) => {
        this.props.editActionItem(this.props.actionItem);
        this.toggleActionItemMenu(event);
        event.preventDefault();
    };

    public deleteActionItem = (event: React.MouseEvent) => {
        this.props.deleteActionItem!(this.props.actionItem).then(() => {
            this.props.getAllActionItems!();
        });
        event.preventDefault();
    };

    public render() {
        const { actionItem, assessment, classes } = this.props;
        const { isToggleColumnMenuOpen, toggleColumnMenuAnchorEl } = this.state;
        const backgroundColor = actionItem.status.name
            ? ActionStatuses[actionItem.status.name]
                ? ActionStatuses[actionItem.status.name].actionItem
                : ''
            : '';
        return (
            <Card className={classes.paper}>
                <Grid container direction="row" spacing={0}>
                    <Grid
                        className={classes.actionItemName}
                        style={{
                            backgroundColor,
                        }}
                        item
                        sm={10}
                        xs={9}
                    >
                        <Typography className={classes.actionItemNameText}>
                            {actionItem.name}
                        </Typography>
                    </Grid>
                    <Grid className={classes.actionItemName} item sm={2} xs={3}>
                        <IconButton
                            aria-controls="simple-menu"
                            aria-label="More"
                            onClick={this.toggleActionItemMenu}
                            className={classes.moreIcon}
                        >
                            <MoreVertIcon className={classes.icon} />
                        </IconButton>
                        <Menu
                            id="simple-menu"
                            anchorEl={toggleColumnMenuAnchorEl}
                            keepMounted
                            open={isToggleColumnMenuOpen}
                            onClose={this.toggleActionItemMenu}
                        >
                            <MenuItem onClick={this.editActionItem}>Edit</MenuItem>
                            <ConfirmMenuItem onClick={this.deleteActionItem}>
                                Delete
                            </ConfirmMenuItem>
                        </Menu>
                    </Grid>
                    <Grid className={classes.actionItemContainers} item xs={12}>
                        <Typography variant="caption" color="textSecondary">
                            Due Date:
                        </Typography>
                    </Grid>
                    <Grid className={classes.actionItemContainers} item xs={12}>
                        <Typography>{moment(actionItem.dueDate).format('MMM DD, YYYY')}</Typography>
                    </Grid>
                    <Grid className={classes.actionItemContainers} item xs={12}>
                        <Typography variant="caption" color="textSecondary">
                            Branch:
                        </Typography>
                    </Grid>
                    <Grid className={classes.actionItemContainers} item xs={12}>
                        <Typography>{assessment.targetBranchName}</Typography>
                    </Grid>
                    <Grid className={classes.actionItemContainers} item xs={12}>
                        <Typography variant="caption" color="textSecondary">
                            Assigned To:
                        </Typography>
                    </Grid>
                    <Grid className={classes.actionItemContainers} item xs={12}>
                        <Typography>{actionItem.assigneeEmail}</Typography>
                    </Grid>
                    <Grid className={classes.actionItemContainers} item xs={12}>
                        <div className={classes.notesNumber}>
                            <ChatBubbleOutlineIcon />
                            {actionItem.notes.length}
                        </div>
                    </Grid>
                </Grid>
            </Card>
        );
    }
}

const InjectedActionItem = inject<IStores, IActionItemProps, Partial<IActionItemProps>, any>(
    (stores: IStores) => ({
        deleteActionItem: stores.actionItems.disableActionItem,
        getAllActionItems: stores.actionItems.getAllActionItems,
    })
)(withStyles(styles)(ActionItem));

export default InjectedActionItem;



// WEBPACK FOOTER //
// ./src/actionItems/ActionItem.tsx